import { useTranslation } from '@frontend/i18n';
import { emptyStateGraphics } from '@frontend/design-system';
import { EmptyState } from './empty-state';

// TODO: Improve this empty state. Maybe match the subscriptions empty state?
export const EmptyStateNoFeatures = () => {
  const { t } = useTranslation('bulk-messaging');
  const MarketingEmptyState = emptyStateGraphics['marketing'];

  return (
    <EmptyState message={t('Weave Marketing is disabled.')}>
      <MarketingEmptyState css={{ width: 375, height: 375 }} />
    </EmptyState>
  );
};
